import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, inject, input } from '@angular/core';
import { Observable } from 'rxjs';

import { DotCmsUveFacade } from '../../facades/dot-cms-uve.facade';
import { BlogContentlet } from '../../models/dot-cms-uve-contentlet.model';

import { DotCmsBlogDetailComponent } from './dot-cms-uve-blog-detail/dot-cms-uve-blog-detail.component';
import { DotCmsBlogPostComponent } from './dot-cms-uve-blog-post/dot-cms-uve-blog-post.component';

@Component({
  selector: 'custom-dot-cms-blog',
  standalone: true,
  templateUrl: './dot-cms-uve-blog.component.html',
  styleUrl: './dot-cms-uve-blog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, DotCmsBlogPostComponent, DotCmsBlogDetailComponent],
})
export class DotCmsUveBlogComponent implements OnChanges {
  readonly contentlet = input<BlogContentlet>(undefined);

  host$: Observable<string>;
  currentPageURI$: Observable<string>;
  previousUrl$: Observable<string>;
  postPageUrl: string;
  dotCmsUveFacade = inject(DotCmsUveFacade);

  ngOnChanges() {
    this.currentPageURI$ = this.dotCmsUveFacade.currentPageUrl();
    this.host$ = this.dotCmsUveFacade.getDotCmsHost$;
  }
  getTags(tagString: string): string[] {
    if (tagString) {
      return tagString.split(',');
    }
    return [];
  }
}
